import { Redirect, router } from 'expo-router';
import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import {
    ArrowRightIcon,
    NavigationTile,
    ScreenContainer,
    SparklesIcon,
    YStack,
} from 'smoothie';
import { v4 as uuidv4 } from 'uuid';

import { StorageKeys } from '../../common/constants';
import storage from '../../common/providers/StorageFacade';
import {
    buildCannedResults,
    CMM_SCENARIOS,
} from '../../llm-service/dev/cmmScenarios';
import { onboardingChatResultsAtom } from '../../llm-service/state/OnboardingChatAtoms';

// Dev-only: skip the CMM conversation by seeding canned results, then jump to
// the results page where the account form lives.
export default function CmmScenarioDevPage() {
    const setOnboardingChatResults = useSetAtom(onboardingChatResultsAtom);

    const handleSelect = useCallback(
        (presetKey: string) => {
            setOnboardingChatResults(buildCannedResults(presetKey));
            // A thread id is required for results.tsx to upsert the results
            // against the visitor, which links the money map to the new member.
            storage.setString(
                StorageKeys.CONVERSATIONAL_MM_THREAD_ID,
                uuidv4(),
            );
            storage.removeItem(
                StorageKeys.HAS_SEEN_CONVERSATIONAL_MM_GUIDED_TOOLTIPS,
            );
            router.push('/sign-up/get-started/results');
        },
        [setOnboardingChatResults],
    );

    // Use process.env directly (not IS_PRODUCTION) so the bundler can
    // dead-code-eliminate this component from production builds.
    if (
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'local' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'sandbox' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'staging'
    ) {
        return <Redirect href="/" />;
    }

    return (
        <ScreenContainer
            title="Canned CMM signup"
            hasBackButton
            onFallbackRoute="/dev"
        >
            <YStack gap={12} paddingBottom={40}>
                {CMM_SCENARIOS.map((scenario) => (
                    <NavigationTile
                        key={scenario.key}
                        title={scenario.title}
                        description={scenario.description}
                        iconLeft={SparklesIcon}
                        iconRight={ArrowRightIcon}
                        onPress={() => {
                            handleSelect(scenario.presetKey);
                        }}
                    />
                ))}
            </YStack>
        </ScreenContainer>
    );
}
